import { jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { textStyles } from "./textStyles.js";
import { token } from "./token.js";
import { Item } from "./Item.js";
function HeadCell({
  onClick,
  isActive = false,
  sortIcon,
  children,
  ...props
}) {
  const isClickable = Boolean(onClick);
  return /* @__PURE__ */ jsx(StyledHeadCell, {
    as: children ? "th" : "td",
    ...props,
    children: isClickable ? /* @__PURE__ */ jsx(Item, {
      onClick,
      rightElements: isActive && sortIcon,
      children: isActive ? /* @__PURE__ */ jsx(Active, {
        children
      }) : children
    }) : /* @__PURE__ */ jsx(Static, {
      children
    })
  });
}
const StyledHeadCell = styled.th.withConfig({
  displayName: "StyledHeadCell",
  componentId: "sc-bzhhdr-0"
})(["", " padding:", " ", ";color:", ";text-align:left;"], textStyles.uiTextM, token.spacing2, token.spacing4, token.colorText);
const Static = styled.div.withConfig({
  displayName: "Static",
  componentId: "sc-bzhhdr-1"
})(["padding:", " 0;"], token.spacing3);
const Active = styled.span.withConfig({
  displayName: "Active",
  componentId: "sc-bzhhdr-2"
})(["font-weight:600;"]);
export {
  HeadCell
};
//# sourceMappingURL=HeadCell.js.map
